export enum BundleDiscountType {
  bundle2 = "bundle2",
  bundle3 = "bundle3",
  bundle4 = "bundle4",
  bundle5 = "bundle5",
  bundle6 = "bundle6",
  BuyGet = "buygetbundle",
}
